


















import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import { AppItemRecord } from '@/tcw/domain/types'
import BasePage from '@/tcw/components/BasePage'
import AppMenuList from '@/components/application/molecules/AppMenuList.vue'

@Component({
  components: { TcwLayoutBasicTemplate, AppMenuList }
})
export default class SetteiListPage extends Mixins(BasePage) {
  private items: AppItemRecord[] = [
    {
      rowId: '1',
      rowLabel: '基本設定',
      appItems: [
        {
          id: 1,
          icon: 'fas fa-arrow-left',
          action: this.back,
          label: '戻る'
        },
        {
          id: 2,
          icon: 'fas fa-user',
          link: '/settei/user',
          label: 'アカウント'
        },
        {
          id: 3,
          icon: 'fas fa-key',
          link: '/settei/password',
          label: 'パスワード'
        }
      ]
    },
    {
      rowId: '2',
      rowLabel: 'パターン',
      appItems: [
        {
          id: 1,
          icon: 'fas fa-project-diagram',
          link: '/settei/project',
          label: 'プロジェクト'
        },
        {
          id: 2,
          icon: 'fas fa-file-alt',
          link: '/pattern/kintai/list',
          label: '勤怠パターン'
        },
        {
          id: 3,
          icon: 'fas fa-file-invoice',
          link: '/pattern/koutsuhi/list',
          label: '交通費パターン'
        }
      ]
    },
    {
      rowId: '3',
      rowLabel: 'その他',
      appItems: [
        {
          id: 1,
          icon: 'fas fa-route',
          link: '/settei/shounin/route',
          label: '承認ルート'
        }
      ]
    }
  ]
}
